import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import CircularProgressbar from 'react-circular-progressbar';
import { get, map } from 'lodash';
import axios from 'axios';
import 'react-circular-progressbar/dist/styles.css';
import HomeCard from '../../containers/HomeCard';
import Loading from '../../components/Loading';
import { API_HOST, UserContext } from '../../consts';
import Ruler from '../../components/Ruler';
import AddButton from '../../components/buttons/AddButton';
import bannerRelatorios from '../../assets/images/plurall_images/banner2.png';
import { Container, Grid } from '@material-ui/core';
import PieChartIcon from '@material-ui/icons/PieChart';

export default class HomePage extends Component {
  state = {
    itens: [],
    mostrarTodasAreasConhecimento: false,
    fetchingItens: true,
    encomendas: []
  };

  render() {
    const legendaDre = 'Diretorias';

    return (
      <>
        <UserContext.Consumer>
          {({ user }) => (
            <Container maxWidth="lg">
              <Grid container item spacing={3}>
                <Grid item xs={12}>
                  <h1
                    style={{
                      marginTop: '25px',
                      fontSize: '30px',
                      fontWeight: 'bold'
                    }}
                  >
                    Olá, {get(user, 'last_name')}
                  </h1>
                </Grid>
              </Grid>
            </Container>
          )}
        </UserContext.Consumer>
        <Grid>
          <div
            style={{
              marginTop: '50px',
              marginBottom: '2rem',
              height: 'auto',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'justify'
            }}
          >
            <div
              style={{
                marginTop: '24px',
                width: 'auto',
                background: '#FFFFFF',
                boxShadow: '0px 2px 8.5px rgba(129, 129, 129, 0.25)',
                padding: '1.7rem',
                borderRadius: '16px'
              }}
            >
              <div className="container mb-4 pb-4">
                <div className="row">
                  <div className="col-12">
                    <div>
                      <div style={{ justifyContent: 'center' }}>
                        <h1 style={{ color: 'rgb(103, 53, 221)' }}>
                          DEVOLUTIVAS PEDAGÓGICAS PROVAS FORMATIVAS DIAGNÓSTICAS
                          E PROCESSUAIS
                        </h1>
                        <br></br>
                      </div>
                      <p>
                        {' '}
                        O sistema de ensino está organizado em três grandes
                        instâncias: o sistema de ensino com toda a sua estrutura
                        de gestão política-pedagógica, as escolas e as salas de
                        aula.{' '}
                      </p>
                      <p>
                        {' '}
                        As escolas situam-se entre as políticas educacionais
                        definidas pelo estado, as diretrizes curriculares, as
                        formas organizativas do sistema e as ações didática-
                        pedagógicas na sala de aula. A escola é, portanto, o
                        espaço de realização tanto dos objetivos do sistema de
                        ensino quanto dos objetivos de aprendizagem. Assim, do
                        ponto de vista de contexto escolar, as análises críticas
                        sobre o sistema de ensino e sobre as políticas
                        educacionais perdem a força analítica, se não tiverem
                        como referência a escola e as salas de aula, do mesmo
                        modo se os profissionais da escola não se sentirem
                        protagonistas de todo processo, podem ter uma visão
                        reduzida da importância do seu papel na melhoria da
                        aprendizagem. Sem a visão sistêmica das políticas
                        públicas educacionais implementadas pela gestão o
                        caminho é mais espinhoso.
                      </p>
                      <p>
                        {' '}
                        Essa relação entre decisões do sistema de ensino e sua
                        efetivação nas escolas revela claramente que as formas
                        de organização e de gestão desempenham um papel
                        educativo, já que dão certa conformação às atitudes, às
                        ideias, e aos modos de agir tanto de professores como de
                        estudantes.{' '}
                      </p>
                      <p>
                        Como principais atores responsáveis pela formação dos
                        estudantes, os professores precisam ter a clareza no
                        entendimento das decisões administrativas e pedagógicas
                        da Rede Estadual de Ensino e de como elas podem afetar
                        positivamente as decisões e as ações pedagógicas levadas
                        a efeito na escola e nas salas de aula.
                      </p>
                      <p>
                        O objetivo do projeto do Sistema Estruturado de Ensino é
                        assegurar que a escola se organize e se constitua em um
                        ambiente educativo, isto é, um espaço de formação e de
                        aprendizagem construído por seus componentes, um lugar
                        em que os profissionais podem decidir com autonomia
                        relativa sobre seu trabalho e aprender mais sobre sua
                        profissão.
                      </p>
                      <p>
                        A assertiva acima, tem objetivo externar que a FGV
                        reconhece que as escolas são ambiente formativos, o que
                        significa que as práticas de organização e de gestão
                        educam, podendo criar ou modificar os modos de pensar e
                        agir. Ou seja, as pessoas mudam com as práticas
                        organizativas, as organizações mudam com as pessoas,
                        desde que possuam subsídios confiáveis e compreendidos
                        para refletir sobre a sua prática pedagógica.
                      </p>
                      <p>
                        {' '}
                        A FGV também reconhece que um dos desafios enfrentados
                        pelos profissionais que conduzem os processos de
                        avaliação, implantação/implementação e acompanhamento do
                        Sistema Estruturado de Ensino é o de promover o
                        entendimento do processo pelos professores.
                        Especialmente relativo à análise de resultado, de modo a
                        estruturar o professor no planejamento escolar,
                        contribuindo para aprendizagem dos estudantes, bem como,
                        na conscientização da importância da mobilização dos
                        estudantes às provas.
                      </p>
                      <p>
                        {' '}
                        Por fim, a equipe de especialistas da FGV reconhece a
                        importância no empenho e no trabalho colaborativo com a
                        Secretaria Estadual de Educação. Esse trabalho permite
                        que se desenvolva ações de mobilização e conscientização
                        da comunidade escolar, visando a participação
                        comprometida às atividades, que inclui as avaliações de
                        aprendizagem formativas processuais (provas bimestrais),
                        e de estratégias capazes de facilitar a compreensão e a
                        apropriação desses resultados pelas diferentes equipes
                        da Secretaria de Educação, Estudantes e demais membros
                        da comunidade escolar.{' '}
                      </p>
                      <p>
                        A equipe de especialistas da FGV ratifica a sua
                        compreensão que no processo de gestão educacional as
                        etapas relativas ao planejamento de um sistema (ou
                        unidade escolar) são a forma segura e racional em se
                        produzir meios e indicadores de controle da dinâmica da
                        realidade escolar.
                      </p>
                      <p>
                        Assim compreendido, no projeto do Sistema Estruturado de
                        Ensino, a avaliação educacional diagnóstica formativa de
                        entrada e de saída e as avaliações formativas
                        processuais (bimestrais) podem ser referenciadas como um
                        processo que coleta, analisa e interpreta evidências
                        relativas à eficácia e à eficiência da estrutura de
                        decisões do programa de escolarização.{' '}
                      </p>
                      <p>
                        No âmbito da unidade escolar, para o planejamento
                        educacional ser válido e fornecer indicadores precisos
                        da dimensão da eficácia e da eficiência, esse controle
                        (processo de avaliação educacional sistêmico e centrado
                        no aluno, isto é, na sua aprendizagem) tem que estar
                        fundamentado no fazer da equipe escolar que,
                        necessariamente, deve ser mobilizada para pensar,
                        raciocinar, agir segundo esse objetivo maior - a
                        aprendizagem do aluno.
                      </p>
                      <p>
                        Neste sentido, as atividades diagnósticas planejadas no
                        projeto são avaliações formativas e processuais que
                        fornecem elementos para a formulação e o monitoramento
                        de políticas públicas, bem como o redirecionamento de
                        práticas pedagógicas.{' '}
                      </p>
                      <p>
                        Para isso, é fundamental compreender que a avaliação
                        deve fornecer subsídios para o planejamento e o
                        desenvolvimento de ações estruturadas a partir da
                        análise e interpretação dos dados e, consequentemente,
                        confirmar ou modificar as próprias decisões e ações
                        planejadas obtenção dos resultados esperados.
                      </p>
                      <p>
                        A essência da parceria FGV / SEDUCMT contempla a
                        execução de atividades que fundamentam a execução do
                        processo sistêmico de avaliações educacionais formativas
                        e disponibiliza uma base de dados, com foco pedagógico
                        no trabalho do professor em sala de aula, e em
                        plataforma online.
                      </p>{' '}
                      <p>
                        Em ambas ferramentas, onde serão possíveis realizar a
                        Atividade Diagnóstica no âmbito da Rede Estadual, das
                        {legendaDre} Regionais de Ensino, das Escolas e Turmas em
                        formato digital, com monitoramento da participação e no
                        acompanhamento dos resultados da avaliação em níveis de
                        acesso, para Estudantes, Professores, Unidades
                        Escolares, {legendaDre} Regionais para atender os
                        seguintes objetivos:
                      </p>
                      <p>
                        <li>
                          Diagnóstico qualificado das necessidades de
                          aprendizagem dos estudantes;
                        </li>
                        <li>
                          Acompanhar a evolução das aprendizagens a partir de
                          provas processuais e medidas estatísticas (TCT e TRI)
                          em avaliação;
                        </li>
                        <li>
                          Subsidiar tomadas de decisão pedagógicas mais
                          assertivas em termos de recuperação assistida e
                          aprofundamento das aprendizagens;
                        </li>
                        <li>
                          Oferecer significado à avaliação, como parte
                          integrante dos processos de ensino e aprendizagem;
                        </li>
                        <li>
                          Garantir recursos para que a rede ganhe autonomia e
                          capacidade técnica para melhor avaliar os estudantes,
                          aprimorando as devolutivas de resultados e planejando
                          intervenções pedagógicas com vistas à melhoria da
                          qualidade da educação;
                        </li>
                        <li>
                          Garantir a utilização de um sistema de avaliação
                          robusto, com tecnologia e metodologia que permitam a
                          capacidade de comparação e respostas estatísticas que
                          darão suporte à definição, implementação e avaliação
                          das ações de recuperação no contexto pós-Covid-19;
                        </li>{' '}
                        e
                        <li>
                          Oferecer subsídios e estratégias para a
                          conscientização e convencimento da comunidade escolar
                          na participação nos testes cognitivos permitindo
                          tomada de decisão durante o processo e garantir que os
                          estudantes desenvolva as habilidades e competências no
                          ano/ série em curso.
                        </li>
                      </p>
                      <p>
                        Na composição dos cadernos de provas diagnósticas
                        formativas de entrada e saída, foi assegurado pelo menos
                        30% dos itens calibrados na escala Saeb. Tal estratégia
                        possibilitou a comparação dos resultados das avaliações
                        diagnósticas formativas de entrada e saída. Por
                        metodologia estatística adequada os itens da prova
                        processual bimestral também foram calibrados na mesma
                        escala, sendo possível gerar de forma virtuosa análise
                        pedagógica, apresentadas nas devolutivas pedagógicas.
                      </p>
                      <p>
                        A metodologia, a logística e o planejamento do processo
                        de execução da avaliação adotadas estruturaram-se na
                        ampla experiência da equipe acadêmica designada pela FGV
                        em processos de avaliações educacionais. Os instrumentos
                        resultaram em bons indicadores de qualidade
                        estatisticamente comprovados e disponibilizados na
                        plataforma on line, no link específico dos relatórios de
                        “Análises Estatísticas pela Teoria Clássica dos Testes e
                        Teoria de Respostas ao Item”. Destaca-se que monitorar a
                        aprendizagem de maneira mais individualizada é
                        importante para professores e gestores.{' '}
                      </p>
                      <p>
                        O sistema de devolutivas do Sistema Estruturado de
                        Ensino da Rede Estadual do Mato Grosso apresenta uma
                        excelente ferramenta referentes aos resultados
                        individuais dos estudantes, por turma, escola e
                        diretoria de ensino, uma vez que apresenta recursos de
                        análise dos resultados referentes aos instrumentos
                        aplicados de forma sistêmica e organizada, utilizando
                        gráficos e tabelas, averiguando os dados a partir da
                        Teoria Clássica dos Testes e da Teoria da Resposta ao
                        Item.
                      </p>
                      <p>
                        {' '}
                        Apresentando, também boletim inteligente, que
                        personaliza a proficiência dos participantes e aponta os
                        conteúdos (objetos de conhecimento), as competências e
                        habilidades que necessitam de reforço nos estudos,
                        fornece, ainda, por meio das análises estatísticas,
                        elementos para que a escola trabalhe na formação
                        continuada de profissionais nas áreas de Currículo e
                        Avaliação da Educação, para constante evolução de seus
                        cursos e metodologias de ensino e aprendizagem.
                      </p>
                      <p>
                        Os relatórios pedagógicos das provas diagnósticas
                        formativas e padronizadas de entrada e saída e das
                        provas processuais formativas seguiram o mesmo desenho,
                        para facilitar a compreensão dos interessados, e estão
                        sendo customizados para atender as especificidades da
                        Rede Estadual de Ensino do Mato Grosso.
                      </p>
                      <p>
                        A agilidade no desenvolvimento de softwares e de
                        conteúdo para a apresentação de instrumentos de medidas
                        e de divulgação dos dados e resultados fez com que a FGV
                        disponibilizasse em plataforma on line as devolutivas
                        pedagógicas no formato de relatórios que atendem às
                        necessidades do projeto do Sistema Estruturado de
                        Ensino. Isso foi possível graças à expertise da FGV e o
                        trabalho desenvolvido utilizando-se metodologia baseada
                        na pesquisa-ação longitudinal, que é a forma de
                        investigação baseada em uma autorreflexão coletiva
                        empreendida pelos participantes de maneira a melhorar a
                        racionalidade de suas práticas, incluindo as
                        educacionais, bem como, com o entendimento das práticas
                        e das situações em que essas práticas acontecem.
                      </p>
                      <p>
                        {' '}
                        O resultado desse trabalho cooperativo e participativo
                        contribuiu para que o modelo de relatórios pedagógicos
                        seja único, assegurando que os técnicos da SEDUC-MT
                        estejam preparados para o atendimento à demanda desejada
                        das unidades escolares, cumprindo assim o seu papel de
                        fornecer subsídios qualificados ao planejamento escolar.
                      </p>
                      <p>
                        {' '}
                        A análise servirá de subsidio à SEDUC e FGV na melhoria
                        contínua dos Planos de Melhorias das escolas e DRES. Os
                        relatórios de participação e pedagógicos de desempenho
                        dos estudantes às provas formativas diagnósticas de
                        entrada e processual – 2º bimestre, por estudante,
                        turma, escola, Diretoria de Ensino e Rede Estadual, já
                        encontram-se com acesso disponível na plataforma on
                        line.{' '}
                      </p>
                      <button
                        style={{
                          color: 'white',
                          backgroundColor: '#9c9c9c',
                          border: 'none',
                          fontSize: '1rem',
                          fontWeight: '600',
                          textAlign: 'center',
                          cursor: 'pointer',
                          borderRadius: '15px',
                          boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                          letterSpacing: '1px',
                          padding: '4px 16px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}
                        onClick={() => window.history.back()}
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* </div> */}
        </Grid>
      </>
    );
  }
}
